import { breakpoints } from '../config/breakpoints';

export function offsetElement(element, offset) {
  const rect = element.getBoundingClientRect();
  let headerHeight = 88;

  if (window.innerWidth < breakpoints.md) {
    headerHeight = 48;
  }

  if (rect.top < headerHeight) {
    const offsetTop = rect.top + window.scrollY - headerHeight - offset;

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    });
  }
}

export default function () {
  document.addEventListener('focusin', (event) => {
    let isHero = false;

    if (event.target.classList.contains('hero-home__nav-content')) {
      isHero = true;
    }

    if (!isHero) {
      const elHeader = event.target.closest('.header');
      const element = event.target;

      if (!elHeader) {
        offsetElement(element, 0);
      }
    }
  });
}
